module.exports = {"$schema":"http://json-schema.org/draft-04/schema#","title":"quality","description":"Ratio for incoming/outgoing transit fees.","type":"number","minimum":1e-9,"maximum":4.294967295}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ripple-lib/dist/npm/common/schemas/objects/quality.json
// module id = VNxr
// module chunks = 1